exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".K7NG8_HeUdqs6d0q_Dal5{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"MarkHomeworkDayView_lessonHomework": "K7NG8_HeUdqs6d0q_Dal5"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/Homework/PaperBased/MarkHomeworkDayView/style.postcss
// module id = 1676
// module chunks = 0